/* eslint-disable camelcase */

import type { BaseTableResultItem, TableResult } from "@tanstack/react-table";

import sharedConstants from "@lib/shared_constants.json";

export interface AppsTransformationsDatatableParams {
  /** the query object containing all the filters */
  query?: Partial<Record<string, string | string[]>>;
  /** the groupby column */
  groupby?: string;
  /** the number of records to return per page */
  limit?: number;
  /** the column on which to sort */
  sortby?: string;
  /** the direction in which to sort */
  sortdir?: -1 | 1;
  /** the index for the first record in the set among the entire response */
  start?: number;
}

export interface AppsTransformationsDatatableResultItem extends BaseTableResultItem {
  id: string;
  url: string;
  name: string;
  approval_status: string;
  updated_at: string;
  total_run_count: number;
  success_run_count: number;
  is_javascript: boolean;
  activation_available: boolean;
  endpoint: TransformationEndpoint;
}

const ENDPOINTS = sharedConstants.DATA_TRANSFORMATION.ENDPOINTS;

export type TransformationEndpoint = (typeof ENDPOINTS)[keyof typeof ENDPOINTS];
export type AppsTransformationsDatatableResult = TableResult<AppsTransformationsDatatableResultItem>;
